<template>
  <div class="row">
    <div class="hidden-xs hidden-sm">
      <div class="web-footer-bar">
        <div class="footer-bar-center spaceBetween">
          <div class="bar-center-list">
            <div class="center-list-title">
              <img src="@/images/label.png" alt="#" class="center-list-img"/>
              <div class="list-title-font">{{type==1?'关于我们':'About Us'}}</div>
              <img src="@/images/label.png" alt="#" class="center-list-img"/>
            </div>

            <div class="center-list-font" v-if="type==1">一个引领健康生活方式的全球公益领导品牌。2003年，由 Sid Lerner 与约翰•霍普金斯大学彭博公共卫生学院合作启动，倡导人们通过简单易行的方式增加植物性饮食，改善人类健康和地球环境。2021年6月，良食基金正式成为蔬适周一的中国官方合作伙伴。</div>
            <div class="center-list-font" v-if="type==2">Meatless Monday was started in 2003 by Sid Lerner, the Founder of The Monday Campaigns, in association with the Johns Hopkins Center for a Livable Future.</div>
          
            <div class="center-list-label" style="display:none">{{type==1?'了解更多':'more'}}>></div>
          </div>

          <!-- <div class="bar-center-list">
            <div class="center-list-title">
              <img src="@/images/label.png" alt="#" class="center-list-img"/>
              <div class="list-title-font">订阅良食资讯</div>
              <img src="@/images/label.png" alt="#" class="center-list-img"/>
            </div>

            <div class="center-list-font">订阅良食大学资讯简报，您每月定期收到良食大学的最新活动通知，美味食谱，以及新闻资讯。</div>
            <div class="center-list-input">
              <div class="list-input-center spaceBetween">
                <input type="text" placeholder="请输入邮箱地址" class="input-center-real"/>
                <img src="@/images/icon8.png" alt="#" class="list-input-img"/>
              </div>
            </div>
            <div class="center-list-label">隐私保护声明</div>
          </div> -->

          <div class="bar-center-list">
            <div class="center-list-title">
              <img src="@/images/label.png" alt="#" class="center-list-img"/>
              <div class="list-title-font">{{type==1?'联系我们':'contact us'}}</div>
              <img src="@/images/label.png" alt="#" class="center-list-img"/>
            </div>

            <div class="center-list-font" v-if="type==1">网站的内容有帮助到您吗？可能您的朋友也很想要了解关于食物的更多知识呢！请记得将蔬适周一分享给家人和朋友哦！有任何意见和建议也可以联系我们！我们期待与您的再次相遇。</div>
            <div class="center-list-font" v-if="type==2">Does the content of the website help you? Maybe your friends also want to know more about food! Please remember to share Meatless Monday with your family and friends! Any comments and suggestions can also contact us! We look forward to meeting you again.</div>
          
            <div class="center-list-label start">
              <img src="@/images/email.png" alt="#" class="list-label-icon"/>
              <img src="@/images/weixin.png" alt="#" class="list-label-icon"/>
              <img src="@/images/weibo.png" alt="#" class="list-label-icon"/>
            </div>
          </div>
        </div>
        <div class="footer-bar-font">© 2021 GOOD FOOD ACADEMY. ALL RIGHTS RESERVED.</div>
      </div>
    </div>

    <div class="hidden-md hidden-lg">
      <div class="phone-footer-bar">
        <div class="footer-bar-centerphone">
          <div class="bar-center-listphone">
            <div class="center-list-titlephone">
              <img src="@/images/label.png" alt="#" class="center-list-imgphone"/>
              <div class="list-title-fontphone">{{type==1?'关于我们':'About us'}}</div>
              <img src="@/images/label.png" alt="#" class="center-list-imgphone"/>
            </div>

            <div class="center-list-fontphone" v-if="type==1">一个引领健康生活方式的全球公益领导品牌。2003年，由 Sid Lerner 与约翰•霍普金斯大学彭博公共卫生学院合作启动，倡导人们通过简单易行的方式增加植物性饮食，改善人类健康和地球环境。2021年6月，良食基金正式成为蔬适周一的中国官方合作伙伴。</div>
            <div class="center-list-fontphone" v-if="type==2">Meatless Monday was started in 2003 by Sid Lerner, the Founder of The Monday Campaigns, in association with the Johns Hopkins Center for a Livable Future.</div>
          
            <div class="center-list-label list-label-phone">{{type==1?'了解更多':'more'}}>></div>
          </div>

          <!-- <div class="bar-center-listphone">
            <div class="center-list-titlephone">
              <img src="@/images/label.png" alt="#" class="center-list-imgphone"/>
              <div class="list-title-fontphone">订阅良食资讯</div>
              <img src="@/images/label.png" alt="#" class="center-list-imgphone"/>
            </div>

            <div class="center-list-fontphone">订阅良食大学资讯简报，您每月定期收到良食大学的最新活动通知，美味食谱，以及新闻资讯。</div>
            <div class="center-list-input list-input-phone" >
              <div class="list-input-center input-center-phone spaceBetween">
                <input type="text" placeholder="请输入邮箱地址" class="input-center-real center-real-phone"/>
                <img src="@/images/icon8.png" alt="#" class="list-input-img input-img-phone"/>
              </div>
            </div>
            <div class="center-list-label center-list-labelphone">隐私保护声明</div>
          </div> -->

          <div class="bar-center-listphone">
            <div class="center-list-titlephone">
              <img src="@/images/label.png" alt="#" class="center-list-imgphone"/>
              <div class="list-title-fontphone">{{type==1?'联系我们':'contact us'}}</div>
              <img src="@/images/label.png" alt="#" class="center-list-imgphone"/>
            </div>

            <div class="center-list-fontphone" v-if="type==1">网站的内容有帮助到您吗？可能您的朋友也很想要了解关于食物的更多知识呢！请记得将蔬适周一分享给家人和朋友哦！有任何意见和建议也可以联系我们！我们期待与您的再次相遇。</div>
            <div class="center-list-fontphone" v-if="type==2">Does the content of the website help you? Maybe your friends also want to know more about food! Please remember to share Meatless Monday with your family and friends! Any comments and suggestions can also contact us! We look forward to meeting you again.</div>
          
            <div class="center-list-label center-list-labelphone start">
              <img src="@/images/email.png" alt="#" class="list-label-iconphone"/>
              <img src="@/images/weixin.png" alt="#" class="list-label-iconphone"/>
              <img src="@/images/weibo.png" alt="#" class="list-label-iconphone"/>
            </div>
          </div>
        </div>
        <div class="footer-bar-fontphone">© 2021 GOOD FOOD ACADEMY. ALL RIGHTS RESERVED.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footerBar',
  data () {
    return {
      type:1
    }
  },
  methods:{
    setType(num){
      const vm=this
      vm.type=num
    }
  },
  computed: {
    
  }
}
</script>

<style scoped>
.row{
  padding: 0;
  margin: 0;
}
.web-footer-bar{
  height: auto;
  padding: 0.25rem 0.5rem 0.1625rem;
  background: #fff;
}
.footer-bar-center{
  width: 100%;
  height: auto;
  border-bottom: 1px solid #d5cdc3;
}
.footer-bar-font{
  margin-top: 0.1625rem;
  font-size: 12px;
  color: #6e615d;
  line-height: 1;
  text-align: left;
  letter-spacing: 2px;
  font-family: "Times New Roman", Times, serif;
}
.bar-center-list{
  width: 48%;
  height: auto;
  margin-bottom: 0.1875rem;
}
.center-list-title{
  width: 1.2rem;
  height: 0.325rem;
  text-align: center;
  line-height: 0.325rem;
  position: relative;
  font-size: 0.15rem;
  color: #6e615d;
  margin-bottom: 0.125rem;
}
.center-list-img{
  width: 0.1625rem;
  height: 0.1125rem;
  position: absolute;
  top: 0;
  left: 0;
}
.center-list-img:last-child{
  bottom: 0;
  right: 0;
  top: auto;
  left: auto;
  transform: rotate(180deg);
}
.center-list-font{
  width: 100%;
  font-size: 0.0875rem;
  color: #6e615d;
  line-height: 1.6;
  text-align: left;
  letter-spacing: 1px;
}
.center-list-label{
  font-size: 0.0875rem;
  color: #c8ae73;
  text-align: left;
  margin-top: 0.1625rem;
  cursor: pointer;
}
.center-list-input{
  width: 2.1375rem;
  height: 0.225rem;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) inset;
  margin-top: 0.1625rem;
}
.list-input-center{
  padding: 0 0.1125rem;
  height: 100%;
}
.list-input-img{
  width: auto;
  height: 0.1rem;
}
.input-center-real{
  flex: 2;
  height: auto;
  font-size: 0.1125rem;
  color: #365b3a;
  border: none;
  background: none;
}
input::placeholder{
  font-size: 0.0875rem;
  color: #aa9b95;
}
.list-label-icon{
  width: 0.15rem;
  height: auto;
  margin-right: 0.1625rem;
}

/**  phone  **/
.phone-footer-bar{
  height: auto;
  padding: 0.8rem 0.6rem 0.6rem;
  /* background: #f2eade; */
}
.footer-bar-centerphone{
  width: 100%;
  height: auto;
  border-bottom: 1px solid #d5cdc3;
}
.footer-bar-fontphone{
  margin-top: 0.4rem;
  font-size: 12px;
  color: #6e615d;
  line-height: 1;
  text-align: left;
  font-family: "Times New Roman", Times, serif;
}
.bar-center-listphone{
  width: 100%;
  height: auto;
  margin-bottom: 0.35rem;
}
.center-list-titlephone{
  width: 3.2rem;
  height: 1rem;
  text-align: center;
  line-height: 1rem;
  position: relative;
  font-size: 0.48rem;
  color: #6e615d;
  margin-bottom: 0.25rem;
}
.center-list-imgphone{
  width: 0.325rem;
  height: 0.225rem;
  position: absolute;
  top: 0;
  left: 0;
}
.center-list-imgphone:last-child{
  bottom: 0;
  right: 0;
  top: auto;
  left: auto;
  transform: rotate(180deg);
}
.center-list-fontphone{
  width: 100%;
  height: auto;
  font-size: 0.32rem;
  line-height: 1.6;
  text-align: left;
  color: #6e615d;
}
.list-label-phone{
  font-size: 0.32rem;
}
.list-input-phone{
  width: 100%;
  height: 1rem;
}
.input-center-phone{
  padding: 0 0.25rem;
  height: 100%;
}
.center-real-phone{
  font-size: 0.32rem;
}
.center-real-phone::placeholder{
  font-size: 0.32rem;
  color: #aa9b95;
}
.input-img-phone{
  width: 0.36rem;
  height: auto;
}
.center-list-labelphone{
  font-size: 0.32rem;
}
.list-label-iconphone{
  width: 0.56rem;
  height: auto;
  margin-right: 0.24rem;
}
</style>
